interface PersonAvatarProps {
  firstName?: string | null;
  lastName?: string | null;
  /** Full name, used when first/last aren't available. */
  name?: string | null;
  size?: number;
}

const initialsOf = ({ firstName, lastName, name }: PersonAvatarProps) => {
  if (firstName || lastName) return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase();
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0]).join('').toUpperCase() || '?';
};

/** Initials on a soft coral tint (one style for everyone; identity is the name, not a color). */
const PersonAvatar = ({ size = 32, ...person }: PersonAvatarProps) => (
  <span
    className="tempo-avatar"
    aria-hidden="true"
    style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.37)) }}
  >
    {initialsOf(person)}
  </span>
);

export default PersonAvatar;
